import React from "react";

export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="px-8 pt-8 pb-5 border-b border-border bg-surface flex items-end justify-between gap-4 flex-wrap" data-testid={testId || "page-header"}>
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-ink">{title}</h1>
        {subtitle && <p className="text-sm text-ink-muted mt-1 font-body">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
